// extracted by mini-css-extract-plugin
export default {"container":"container__nDX5WY","icon":"icon__nXfBmJ"};